import { Subject, Subscription, Observable } from "rxjs";
import { useEffect, useMemo, useState } from "react";

export default function useObservable<T>(observable: Observable<T>, initial?: T, inputs = []) {
  const [state, setState] = useState(initial);
  const subject = useMemo(() => new Subject(), inputs);

  useEffect(() => {
    const subscription = new Subscription();
    subscription.add(subject);
    subscription.add(subject.pipe(() => observable).subscribe(value => setState(value)));
    return () => subscription.unsubscribe();
  }, [subject]);

  return state;
}
